module.exports = __webpack_public_path__ + "img/eskisehir-osmangazi-uni-logo.0e17b5a2.jpg";